import { render, staticRenderFns } from "./jobPreview.vue?vue&type=template&id=71ad519e&scoped=true"
import script from "./jobPreview.vue?vue&type=script&lang=js"
export * from "./jobPreview.vue?vue&type=script&lang=js"
import style0 from "./jobPreview.vue?vue&type=style&index=0&id=71ad519e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad519e",
  null
  
)

export default component.exports